import { isCustomRole } from "./index";
import isEmpty from "lodash/isEmpty";

export const isAllowedToCreate = (resource_type) => {
  //If traditional roles, skip this check and return true
  if (!isCustomRole()) {
    return true;
  }

  const permissions = JSON.parse(
    localStorage.getItem("authz-create-permissions")
  );

  //if backend returns null or undefined, do not allow
  if (isEmpty(permissions)) {
    return false;
  }

  return permissions.includes(resource_type);
};
